import { defineNuxtPlugin } from 'nuxt/app';
import { preloadComplexTokensImages } from '~/composables/useTokensConfig';

export default defineNuxtPlugin(async () => {
  await preloadComplexTokensImages();
});
